import axios from 'axios';

export const listRfqs = async (params = {}) => {
  const response = await axios.get('/api/rfqs', { params });
  return response.data;
};

export const createRfq = async (payload) => {
  const response = await axios.post('/api/rfqs', payload);
  return response.data.rfq ?? response.data;
};

export const getRfq = async (rfqId) => {
  const response = await axios.get(`/api/rfqs/${rfqId}`);
  return response.data.rfq ?? response.data;
};

export const updateRfq = async (rfqId, payload) => {
  const response = await axios.patch(`/api/rfqs/${rfqId}`, payload);
  return response.data.rfq ?? response.data;
};

export const assignRfqPartners = async (rfqId, partnerIds = []) => {
  const response = await axios.post(`/api/rfqs/${rfqId}/assign`, { partnerIds });
  return response.data.rfq ?? response.data;
};
